import { Box, Button } from '@mui/material';
import Card from '@mui/material/Card';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { useEffect, useState } from 'react';
import { MDButton } from '../MDButton';
import { LoadingButton } from '@mui/lab';

interface IWizardProps {
  stepLabels: Array<string>;
  steps: Array<any>;
  lastStepActionLabel: string;
  lastStepAction?: () => void;
  onStepChange?: any;
  buttonLoading?: boolean;
  handleNext?: boolean;
  handleNextCount?: number;
  showOnlyWizard?: boolean;
  removeShadow?: boolean;
  initialStep?: number;
}

export const Wizard: React.FC<IWizardProps> = (props: IWizardProps) => {
  const [activeStep, setActiveStep] = useState(props.initialStep ?? 0);
  const steps = props.stepLabels;
  const isLastStep = activeStep === steps.length - 1;

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  }

  useEffect(() => {
    if (props.handleNextCount != undefined) {
      if (props.handleNextCount === -1) {
        setActiveStep(0);
      }
      else {
        if ((props.handleNextCount + 1) >= activeStep) {
          handleNext();
        }
        else {
          handleBack();
        }
      }
    }
  }, [props.handleNextCount])

  useEffect(() => {
    if (props.initialStep) {
      setActiveStep(props.initialStep);
    }
  }, [props.initialStep])

  const getStepContent = (stepIndex: number) => {
    return stepIndex < props.steps.length ? props.steps[stepIndex] : null;
  }

  const getChildrenComponent = (): JSX.Element => {
    return (
      <Box height="100%">
        <Box mt={-3}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Box mt={2} mb={1} ml={1} mr={1}>
          <>
            {getStepContent(activeStep)}
            <Box mt={3} width='100%' display='flex' justifyContent='space-between'>
              {props.handleNext || activeStep === 0 ? (
                <Box />
              ) : (
                <MDButton variant='outlined' color='dark' onClick={handleBack}>
                  back
                </MDButton>
              )}
              {!props.handleNext && (
                <LoadingButton
                  loading={props.buttonLoading}
                  variant="contained"
                  color="primary"
                  onClick={!isLastStep ? handleNext : props.lastStepAction}
                >
                  {!isLastStep ? 'next' : props.lastStepActionLabel}
                </LoadingButton>
              )}
            </Box>
          </>
        </Box>
      </Box>
    );
  };

  return (
    <>
      {
        props.showOnlyWizard ?
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          :
          <Box mb={-1}>
            {props.removeShadow ? <>{getChildrenComponent()}</> : <Card>{getChildrenComponent()}</Card>}
          </Box>
      }
    </>
  );
}
